import { getMessaging, getToken, onMessage } from "firebase/messaging";

import NotificationAPI from "../../pages/my-account/notifications/NotificationAPI";
import { initializeApp } from "firebase/app";

// chave local pra comparar e evitar chamadas desnecessárias
const LS_FCM_TOKEN_KEY = "hallapp_fcm_token_web";

const firebaseConfig = {
  apiKey: "AIzaSyAI0-jgyFVr8LZdpV1SbHzEKFmCxMTZUnQ",
  authDomain: "hallapp-prd.firebaseapp.com",
  projectId: "hallapp-prd",
  storageBucket: "hallapp-prd.firebasestorage.app",
  messagingSenderId: "806925843880",
  appId: "1:806925843880:web:2e3ac45dc8a7aeb0ff719d",
  measurementId: "G-7J0M5M9RGG",
};

const app = initializeApp(firebaseConfig);

async function getSwRegistrationReady() {
  // se ainda não tiver registration, registra (sem competir)
  let reg = await navigator.serviceWorker.getRegistration("/");
  if (!reg) {
    reg = await navigator.serviceWorker.register("/pwabuilder-sw.js", { scope: "/" });
  }

  await navigator.serviceWorker.ready;
  return await navigator.serviceWorker.getRegistration("/");
}


export async function requestNotificationPermissionAndToken(vapidKey) {
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { token: null, permission };

  const swReg = await getSwRegistrationReady();
  if (!swReg) return { token: null, permission };

  const messaging = getMessaging(app);

  const token = await getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration: swReg,
  });

  return { token, permission };
}

/**
 * ✅ Foreground listener (app aberto)
 * Retorna um unsubscribe pra você limpar no useEffect
 */
export function listenForegroundMessages(handler) {
  const messaging = getMessaging(app);

  return onMessage(messaging, (payload) => {
    const title =
      payload?.notification?.title || payload?.data?.title || "Hallapp";

    const body =
      payload?.notification?.body || payload?.data?.body || "Nova notificação";

    handler({ title, body, payload });
  });
}

export async function syncFcmTokenOnAppStart({ vapidKey, companyId }) {
  try {
    if (Notification.permission !== "granted") return;

    const swReg = await getSwRegistrationReady();
    if (!swReg) return;

    const messaging = getMessaging(app);

    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swReg,
    });


    if (!token) return;

    const last = localStorage.getItem("hallapp_fcm_token_web");
    if (last !== token) {
      localStorage.setItem("hallapp_fcm_token_web", token);

      await new NotificationAPI().saveConnectionToFirebase({
        token,
        companyId,
        enabled: true,
        platform: "WEB",
      });
    }
  } catch (e) {
    console.warn("syncFcmTokenOnAppStart failed", e);
  }
}

